import { FaFolder, FaTrash, FaGripVertical } from "react-icons/fa";
import { HiOutlineCubeTransparent } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import "../../../styles/studio/folder/studioFolderEntryRow.css";
import { removeItemFromFolder } from "../../../services/folder.service";

const typeIcons = {
  folder: FaFolder,
  visualization: HiOutlineCubeTransparent,
  publication: HiOutlineCubeTransparent,
};

const StudioFolderEntryRow = ({
  entry,
  index,
  hovered,
  onHover,
  onLeave,
  currentFolderPath = [], // ✅ single source of truth
  fetchData,
  globalLoading = false,
  setGlobalLoading,
  showIndex = true,
  setError,
}) => {
  const navigate = useNavigate();
  const { type, item, itemId, folderEntryId } = entry;

  const uiType = type === "publication" ? "visualization" : type;
  const Icon = typeIcons[type] || HiOutlineCubeTransparent;

  // ✅ derive current folder id
  const folderId = currentFolderPath[currentFolderPath.length - 1];

  // remove root for route building
  const pathWithoutRoot = currentFolderPath.slice(1);

  /* ---------------- NAVIGATION ---------------- */
  const handleNavigate = () => {
    if (globalLoading) return;

    if (uiType === "folder") {
      navigate(`/studio/folders/${[...pathWithoutRoot, itemId].join("/")}`);
    }
  };

  /* ---------------- REMOVE ITEM ---------------- */
  const handleDelete = async (e) => {
    e.stopPropagation();
    if (globalLoading) return;
    if (!confirm("Remove this item from folder?")) return;

    try {
      setGlobalLoading?.(true);
      await removeItemFromFolder(folderId, folderEntryId);
      await fetchData();
    } catch (err) {
      setError(err.message);
    } finally {
      setGlobalLoading?.(false);
    }
  };

  return (
    <div
      className={`studio-folder-entry-row ${hovered ? "hovered" : ""} ${
        !item?.description ? "no-desc" : ""
      }`}
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
      onClick={handleNavigate}
      style={{ pointerEvents: globalLoading ? "none" : "auto" }}
    >
      <div className="studio-folder-entry-drag">
        <FaGripVertical />
      </div>

      {showIndex && (
        <div className="studio-folder-entry-index">{index + 1}</div>
      )}

      <div className="studio-folder-entry-icon">
        <Icon />
      </div>

      <div className="studio-folder-entry-text">
        <div className="studio-folder-entry-title" title={item?.title}>
          {item?.title}
        </div>
        {item?.description && (
          <div
            className="studio-folder-entry-description"
            title={item.description}
          >
            {item.description}
          </div>
        )}
      </div>

      <div className="studio-folder-entry-badge-container">
        <div className={`studio-folder-entry-badge badge-${uiType}`}>
          {uiType}
        </div>
      </div>

      <button
        className="studio-folder-entry-delete"
        onClick={handleDelete}
        disabled={globalLoading}
        title={globalLoading ? "Please wait..." : "Remove from folder"}
      >
        <FaTrash />
      </button>
    </div>
  );
};

export default StudioFolderEntryRow;
